// src/pages/TestOrders/sections/FacilityAndPhysicianSection.jsx
import {
    Box,
    FormControl,
    FormErrorMessage,
    FormLabel,
    SimpleGrid,
    Spinner,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import {
    getAllFacilitiesOutside,
    getPhysiciansByFacilityOutside,
} from '../../../../api';

const FacilityAndPhysicianSection = ({ formData, setFormData }) => {
    const [facilityOptions, setFacilityOptions] = useState([]);
    const [physicianOptions, setPhysicianOptions] = useState([]);
    const [loadingPhysicians, setLoadingPhysicians] = useState(false);

    // 🚀 Fetch facilities once on load
    useEffect(() => {
        (async () => {
            const facRes = await getAllFacilitiesOutside();
            if (facRes.success) {
                const list = facRes.data?.facilities || [];
                setFacilityOptions(list.map((f) => ({ value: f._id, label: f.name })));
            }
        })();
    }, []);

    const handleFacilityChange = async (option) => {
        setFormData({
            ...formData,
            facilityId: option?.value || null,
            physicianId: null, // reset physician if facility changes
        });
        setPhysicianOptions([]);
        if (option) {
            setLoadingPhysicians(true);
            const res = await getPhysiciansByFacilityOutside(option.value);
            if (res.success) {
                const list = res.data?.physicians || [];
                setPhysicianOptions(list.map((p) => ({ value: p._id, label: p.fullName })));
            }
            setLoadingPhysicians(false);
        }
    };

    return (
        <Box p={4} borderWidth="1px" rounded="md" shadow="sm">
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                {/* Facility (Required) */}
                <FormControl isInvalid={!formData.facilityId} isRequired>
                    <FormLabel>Facility</FormLabel>
                    <Select
                        options={facilityOptions}
                        value={
                            facilityOptions.find((opt) => opt.value === formData.facilityId) || null
                        }
                        onChange={handleFacilityChange}
                        placeholder="Select Facility"
                    />
                    {!formData.facilityId && (
                        <FormErrorMessage>Facility is required</FormErrorMessage>
                    )}
                </FormControl>

                {/* Physician (Required) */}
                {loadingPhysicians ? (
                    <Spinner size="lg" />
                ) : (
                    <FormControl isInvalid={!formData.physicianId} isRequired>
                        <FormLabel>Physician</FormLabel>
                        <Select
                            options={physicianOptions}
                            value={
                                physicianOptions.find(
                                    (opt) => opt.value === formData.physicianId
                                ) || null
                            }
                            onChange={(opt) =>
                                setFormData({ ...formData, physicianId: opt?.value || null })
                            }
                            placeholder="Select Physician"
                            isDisabled={!formData.facilityId}
                        />
                        {!formData.physicianId && (
                            <FormErrorMessage>Physician is required</FormErrorMessage>
                        )}
                    </FormControl>
                )}
            </SimpleGrid>
        </Box>
    );
};

export default FacilityAndPhysicianSection;
